import { rgba } from "polished";
import { Spacer } from "shared/layout";
import { borderRadius, breakpoint, colors, space } from "shared/styles/constants";
import styled from "styled-components";

export const StyledAccommodationBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  ${breakpoint("s", "down")} {
    flex-direction: column;
  }

  @media print {
    display: block;
  }
`;

export const StyledAccommodationRow = styled.div`
  @media print {
    display: block;
    margin: ${space.m};
    page-break-inside: avoid;

    > *:first-child {
      padding-right: ${space.m};
    }
    > * {
      vertical-align: top;
      display: inline-block;
      width: 50%;
    }
  }
`;

export const StyledMap = styled.div`
  margin-left: ${space.m};

  ${breakpoint("s", "down")} {
    order: -1;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${space.m};
  }

  @media print {
    display: none;
  }
`;

export const StyledAccommodationRoomsBlock = styled(Spacer)`
  margin-top: ${space.m};

  @media print {
    page-break-inside: avoid;
    background-color: ${colors.grey6};
    margin: 0 !important;
    padding: ${space.s};

    * {
      background-color: ${colors.grey6};
    }
  }
`;

export const StyledAccommodationPeopleBlock = styled(Spacer)`
  @media print {
    margin-top: 0 !important;
    > * {
      margin-top: 0 !important;
    }
  }
`;

export const StyledPersonalReservationTeaser = styled.div`
  padding: ${space.m};
  margin: ${space.m} 0;
  width: 50%;
  border: 1px solid ${rgba(colors.yellow, 0.5)};
  background-color: ${rgba(colors.yellow, 0.1)};
  border-radius: ${borderRadius.s};

  @media print {
    background-color: ${colors.yellowLight};
    margin: 0;
  }
`;
